$('#terms_accept_terms').click(function () {

    let url = $(this).attr('data-ajax-url');
    $(this).attr('readonly','readonly');
    $(this).attr('disabled',true);
    $(this).attr('checked',true);
    let text = $('label',$(this).parent()).html();
    let label = $('label',$(this).parent());
    let checkbox = $(this);
    label.prepend('<i class="fas fa-spinner fa-pulse"></i>');

    post(url, {test: 'test'},'html').then(r  => {
        if(r.ok){
            r.text().then(function (content){
                $('#accept_terms_buttons').html(content);
                $('#accept_terms_buttons').collapse('show');
                checkbox.addClass('bg-success');
                label.html(text);
            });
        }else{

        }
    });
});
